const tr = {
  loading: "Loading...",
  not_found: "Kayıt bulunamadı",
  error_occurred: "Beklenmedik bir hata oldu. Lütfen tekrar deneyiniz.",

  add_new_ticket_type: "Yeni bir bilet tipi ekle",
  add_new_branch: "Yeni Şube Ekle",
  add: "Oluştur",
  update: "Güncelle",
  agree: "Onayla",
  confirm: "Onayla",
  save: "Kaydet",
  cancel: "Vazgeç",
  attention: "Dikkat",
  title: "Başlık",
  name: "Ad",
  surname: "Soyad",
  icon: "İkon",
  currencies: "Para Birimleri",

  description: "Açıklama",
  payment_types: "Ödeme Türleri",
  delete: "Sil",
  reservation_date: "Rezervasyon Tarihi",
  user: "Kullanıcı",
  paid_date: "Ödeme Tarihi",
  ticket_types: "Bilet Türleri",

  delete_confirmation_message: "Silmek istediğinizden emin misiniz?",
  delete_message: "Silme işlemine devam etmek istiyor musunuz?",
  delete_success_message: "Silme işlemi başarıyla tamamlandı",

  create_success_message: "Kayıt başarıyla oluşturuldu",
  update_success_message: "Kayıt başarıyla güncellendi",

  email: "Email",
  address: "Adres",
  phone: "Telefon",
  close: "Kapat",
  group_drag_field_description:
    "Kolonu gruplamak için kolon başlığından sürükleyip buraya bırakın.",
  branchs: "Şubeler",
  countries: "Ülkeler",

  search: "Ara ...",

  prefix: "Ön Ek",
  branch: "Şube",
  ticket_type: "Bilet Türü",
  comission_rate: "Komisyon Oranı",
  code_length: "Kod Uzunluğu",
  current_index: "Mevcut Sıra",

  code: "Kod",
  picture: "Resim",
  name_surname: "Ad Soyad",
  username: "Kullanıcı Adı",
  password: "Şifre",
  confirm_password: "Şifre Onayı",

  employee: "Personel",
  customer: "Müşteri",
  total_amount: "Toplam Tutar",
  deposit: "Depozito",
  rest: "Kalan",
  currency: "Döviz",
  status: "Durum",

  validation: {
    required: "{{field}} alanı zorunludur",
    email: "Geçerli bir email adresi giriniz",
  },
  table_search: "Ara",

  menu: {
    pdf_design: "Pdf Design",
    dashboard: "Gösterge Paneli",
    branches: "Şube Yönetimi",
    branch_comissions: "Şube Komisyonları",
    middlemen: "Hanutçular",
    middleman_sales: "Hanutçu Satışları",
    employees: "Personel Yönetimi",
    tickets: "Bilet Yönetimi",
    transfers: "Transferler",
    sales: "Satış İşlemleri",
    money_flow: "Kasa İşlemleri",
    premium_payments: "Prim Ödemeleri",
    settings: "Sistem Ayarları",
    currencies: "Döviz Türleri",
    payment_types: "Ödeme Türleri",
    ticket_types: "Bilet Türleri",
    ticket_numbers: "Bilet Numaraları",
    comission_percentages: "Komisyon Oranları",
    countries: "Ülkeler",
  },
};
export default tr;
